import React from 'react';

import Icon from '@buyside/components/presentation/Icon/icon';

import AcquisitionIcon from '@buyside/svgs/corporate_actions/acquisition.svg';
import BankruptcyIcon from '@buyside/svgs/corporate_actions/bankruptcy.svg';
import MajorFallIcon from '@buyside/svgs/corporate_actions/major_fall.svg';
import MajorRiseIcon from '@buyside/svgs/corporate_actions/major_rise.svg';
import PrivatizationIcon from '@buyside/svgs/corporate_actions/privatization.svg';
import SpinOffIcon from '@buyside/svgs/corporate_actions/spin_off.svg';

import { ActivityFeedCorporateActionFragment } from '@interfaces/graphql-typings';

import styles from './headerStyles.scss';

const Header: React.FC<{
  corporateAction: ActivityFeedCorporateActionFragment;
  timeframe: string;
}> = ({ corporateAction, timeframe }): React.ReactElement => {
  const {
    actionType,
    childEntity,
    parentActionPeriodReturn,
    parentAsset,
    parentEntity
  } = corporateAction;

  const renderHeaderLabel = (): string => {
    if (actionType === 'major-rise' || actionType === 'major-fall') {
      return 'Market Trends';
    } else {
      return 'Major Corporate Action';
    }
  };

  const renderHeaderText = (): React.ReactElement => {
    if (actionType === 'acquisition') {
      return (
        <h4>
          {parentEntity?.name} {parentEntity?.primarySymbol}
          <br />
          Acquires {childEntity?.name} <small>({childEntity?.primarySymbol})</small>
        </h4>
      );
    } else if (actionType === 'privatization') {
      return (
        <h4>
          {parentEntity?.name} <small>({parentEntity?.primarySymbol})</small>
          <br />
          has gone private
        </h4>
      );
    } else if (actionType === 'bankruptcy') {
      return (
        <h4>
          {parentEntity?.name} <small>({parentEntity?.primarySymbol})</small>
          <br />
          has filed for bankruptcy
        </h4>
      );
    } else if (actionType === 'spinoff') {
      return (
        <h4>
          {parentEntity?.name} <small>({parentEntity?.primarySymbol})</small>
          <br />
          has spun off {childEntity?.name} <small>({childEntity?.primarySymbol})</small>
        </h4>
      );
    } else if (actionType?.match('change')) {
      //actionType = [seven, thirty]_day_[rise, fall]
      const direction = Number(parentActionPeriodReturn) > 0 ? 'risen' : 'fallen';
      //thresholds for now are 10% in 7 days and 30% in 30 days
      const threshold = actionType.match('thirty') ? '20' : '10';

      return (
        <h4>
          {parentAsset?.name} <small>({parentAsset?.symbol})</small>
          <br />
          has {direction} more than {threshold}% in the past {timeframe} days.
        </h4>
      );
    }
    return <></>;
  };

  const iconTypes = {
    acquisition: AcquisitionIcon,
    bankruptcy: BankruptcyIcon,
    privatization: PrivatizationIcon,
    seven_day_change: Number(parentActionPeriodReturn) > 0 ? MajorRiseIcon : MajorFallIcon,
    spinoff: SpinOffIcon,
    thirty_day_change: Number(parentActionPeriodReturn) > 0 ? MajorRiseIcon : MajorFallIcon
  };

  return (
    <div className={styles.headerWrap}>
      <div className={styles.corporateActionHeader}>
        {actionType && (
          <Icon type={iconTypes[actionType as keyof typeof iconTypes]} style={styles.mainIcon} />
        )}
        <div className={styles.headerContent}>
          <p className={styles.actionLabel}>{renderHeaderLabel()}</p>
          {renderHeaderText()}
        </div>
      </div>
    </div>
  );
};

export default Header;
